// 天转毫秒
function day2ms(day) {
  return day * 24 * 60 * 60 * 1000
}

export default {
  data: () => ({

  }),

  computed: {
    datePickerBind: (vm) => ({
      type: 'daterange',
      startPlaceholder: vm.$vnode.tag.indexOf('FinanceWithdraw')>0  ? '申请时间' : '下单时间',
      endPlaceholder: vm.$vnode.tag.indexOf('FinanceWithdraw')>0 ? '申请时间' : '下单时间',
      format: 'yyyy-MM-dd',
      align: 'center',
      editable: false,
      rangeSeparator: '至',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > new Date(new Date().toLocaleDateString()).getTime() + 86400 * 1000 - 1
        },
        shortcuts: [
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - day2ms(7))
              picker.$emit('pick', [date, new Date()])
            },
          },
          {
            text: '一月前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - day2ms(30))
              picker.$emit('pick', [date, new Date()])
            },
          },
          {
            text: '三月前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - day2ms(90))
              picker.$emit('pick', [date, new Date()])
            },
          },
          {
            text: '一年前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - day2ms(365))
              picker.$emit('pick', [date, new Date()])
            },
          },
        ],
      },
    }),
  },
}

